export default {
  title: 'Registro de Auditoría',
  exportCsv: 'Exportar CSV',
  refresh: 'Actualizar',
  startDateLabel: 'Fecha de Inicio',
  endDateLabel: 'Fecha de Fin',
  actionTypeLabel: 'Tipo de Acción',
  targetUserEmailLabel: 'Email del Usuario Objetivo',
  viewChanges: 'Ver Cambios',
  changeDetailsTitle: 'Detalles del Cambio',
  actionLabel: 'Acción:',
  performedByLabel: 'Realizado Por:',
  targetUserLabel: 'Usuario Objetivo:',
  modelIdLabel: 'ID del Modelo:',
  timestampLabel: 'Fecha y Hora:',
  changesTitle: 'Cambios',
  beforeLabel: 'Antes:',
  afterLabel: 'Después:',
  headerTimestamp: 'Fecha y Hora',
  headerAction: 'Acción',
  headerPerformedBy: 'Realizado Por',
  headerTargetUser: 'Usuario Objetivo',
  headerModelId: 'ID del Modelo',
  headerChanges: 'Cambios',
  actionGrantAccess: 'Otorgar Acceso',
  actionRevokeAccess: 'Revocar Acceso',
  actionGrantReferenceAccess: 'Otorgar Acceso de Referencia',
  actionRevokeReferenceAccess: 'Revocar Acceso de Referencia',
  actionGrantEkrmAccess: 'Otorgar Acceso EKRM',
  actionRevokeEkrmAccess: 'Revocar Acceso EKRM',
  actionDeleteUser: 'Eliminar Usuario',
  actionGrantGroupAccess: 'Otorgar Acceso a Grupo',
  actionRevokeGroupAccess: 'Revocar Acceso a Grupo',
  actionCreateGroup: 'Crear Grupo',
  actionDeleteGroup: 'Eliminar Grupo',
  actionGrantGroupModelAccess: 'Otorgar Acceso de Modelo a Grupo',
  actionRevokeGroupModelAccess: 'Revocar Acceso de Modelo a Grupo',
  actionGrantGroupReferenceAccess: 'Otorgar Acceso de Referencia a Grupo',
  actionRevokeGroupReferenceAccess: 'Revocar Acceso de Referencia a Grupo',
  actionGrantGroupEkrmAccess: 'Otorgar Acceso EKRM a Grupo',
  actionRevokeGroupEkrmAccess: 'Revocar Acceso EKRM a Grupo',
  actionUnknown: 'Acción Desconocida',
  timestampNA: 'N/D',
  timestampInvalid: 'Fecha Inválida',
  exportSuccess: 'Registros de auditoría exportados exitosamente',
  exportError: 'Error al exportar registros de auditoría: ',
  loadError: 'Error al cargar registros de auditoría: ',
  indexErrorHint: ' Intente eliminar algunos filtros para reducir la complejidad de la consulta.'
}
